import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="tabs"
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { activeTab: String }

  connect() {
    this.showActiveTab()
  }

  switch(event) {
    event.preventDefault()

    const clickedTab = event.currentTarget
    const tabName = clickedTab.dataset.tabsTabParam

    this.setActiveTab(tabName)
  }

  setActiveTab(tabName) {
    // Remove active class from all tabs
    this.tabTargets.forEach(tab => {
      tab.classList.remove("tab-active")
    })

    // Hide all panels
    this.panelTargets.forEach(panel => {
      panel.classList.add("hidden")
    })

    // Activate the selected tab
    const activeTab = this.tabTargets.find(tab =>
      tab.dataset.tabsTabParam === tabName
    )
    if (activeTab) {
      activeTab.classList.add("tab-active")
    }

    // Show the selected panel
    const activePanel = this.panelTargets.find(panel =>
      panel.dataset.tabsPanelParam === tabName
    )
    if (activePanel) {
      activePanel.classList.remove("hidden")
    }

    // Update the active tab value
    this.activeTabValue = tabName
  }

  showActiveTab() {
    // Find the tab that should be active by default
    const defaultActiveTab = this.tabTargets.find(tab =>
      tab.classList.contains("tab-active")
    )

    if (defaultActiveTab) {
      const tabName = defaultActiveTab.dataset.tabsTabParam
      this.setActiveTab(tabName)
    } else if (this.tabTargets.length > 0) {
      // If no tab is marked as active, activate the first one
      const firstTab = this.tabTargets[0]
      const tabName = firstTab.dataset.tabsTabParam
      this.setActiveTab(tabName)
    }
  }
}